interface PatientIdentifiersProps {
  patientName?: string;
  patientId?: string;
  age?: string;
  patientImageUrl?: string;
  gender?: string;
}

const PatientIdentifiers = (props: {
  patientIdentifierData: PatientIdentifiersProps;
}) => {
  const generatePatientImageUrl = () => {
    if (props?.patientIdentifierData?.patientImageUrl) {
      return props.patientIdentifierData.patientImageUrl;
    }

    switch (props?.patientIdentifierData?.gender) {
      case "Male".toLowerCase():
        return "/userMale.png";

      case "Female".toLowerCase():
        return "/userFemale.png";

      default:
        return "/user.png";
    }
  };
  return (
    <div className="patient-identifiers--container">
      <div className="patient-identifiers--image">
        <img src={generatePatientImageUrl()} alt="patient-image" />
      </div>
      <div className="patient-identifiers--information">
        <div className="patient-identifiers--information__name">
          {props?.patientIdentifierData?.patientName}
        </div>
        <div className="patient-identifiers--information__mrn">
          MRN : {props?.patientIdentifierData?.patientId}
        </div>
        <div className="patient-identifiers--information__age">
          Age: {props?.patientIdentifierData?.age}
        </div>
      </div>
    </div>
  );
};

export default PatientIdentifiers;
